import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { Link, browserHistory, Route, withRouter, Switch, BrowserRouter as Router } from 'react-router-dom';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import Card, { CardContent, CardMedia } from 'material-ui/Card';
import List from 'material-ui/List';
import Divider from 'material-ui/Divider';
import styles from './styles.js';
import { push } from 'react-router-redux';

// Icons
import InboxIcon from 'material-ui-icons/MoveToInbox';
import DraftsIcon from 'material-ui-icons/Share';
import StarIcon from 'material-ui-icons/Star';
import BuildIcon from 'material-ui-icons/Code';
import MailIcon from 'material-ui-icons/Mail';
import DeleteIcon from 'material-ui-icons/Delete';
import ReportIcon from 'material-ui-icons/Report';
import PersonIcon from 'material-ui-icons/Person';
import PhoneIcon from 'material-ui-icons/PhoneInTalk';
import HomeIcon from 'material-ui-icons/Home';
import LogoutIcon from 'material-ui-icons/Reply';
import SettingsIcon from 'material-ui-icons/Settings';
import SearchIcon from 'material-ui-icons/Search';

// Components
import Home from './components/Home';
import Search from './components/Search';
import MyProfiles from './components/MyProfiles';
import Communication from './components/Communication';
import Profile from './components/Profile';
import Support from './components/Support';
import Contact from './components/Contact';
import LogOut from './components/LogOut';
import SpecialServices from './components/SpecialServices';
import NonSelected from './components/NonSelected';
import ServiceLevel from './components/ServiceLevel';
import SubmitBUG from './components/SubmitBUG';

class SideItems extends Component {
  render(){
    const { classes, theme } = this.props;

    // Project_id from Redux
    // '/projects/'+ this.props.project_id
    const TO_PREFIX = "/console";

    let iconHighlighted = classes.iconFontSizeHighlighted;
    let textHighlighted = classes.textFontSizeHighlighted;

    return(
      <ConnectedSwitch>
        <Route exact path='/console' location={this.props.location} component={Home}/>
        <Route path='/console/display' location={this.props.location} component={Home}/>
        <Route path='/console/search' location={this.props.location} component={Search}/>
        <Route path='/console/my_profiles' location={this.props.location} component={MyProfiles}/>
        <Route path='/console/special_services' location={this.props.location} component={SpecialServices}/>
        <Route path='/console/communication' location={this.props.location} component={Communication}/>
        <Route path='/console/service_level' location={this.props.location} component={ServiceLevel}/>
        <Route path='/console/submit_bug' location={this.props.location} component={SubmitBUG}/>
        <Route path='/console/profile' location={this.props.location} component={Profile}/>
        <Route path='/console/support' location={this.props.location} component={Support}/>
        <Route path='/console/contact' location={this.props.location} component={Contact}/>
        <Route path='/console/logout' location={this.props.location} component={LogOut}/>
        <Route path='/console/user' location={this.props.location} component={NonSelected}/>
        <Route path='/console/all_communication' location={this.props.location} component={NonSelected}/>
        <Route path='/console/oarreport' location={this.props.location} component={NonSelected}/>
      </ConnectedSwitch>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        counter: state.counter,
        router: state.router
    };
}

const ConnectedSwitch = connect(state => ({
  location: state.location
}))(Switch)

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps,mapDispatchToProps)(SideItems)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/SideDrawer/components/DrawerMenu/components/SideItems/index.js